export default "__VITE_ASSET__BgS_ixjm__"